import styled from 'styled-components';
import theme from '../../const/theme';

export const ContactContainer = styled.div`
    max-width: 1250px;
    width: 100%;
    margin: 70px auto;
    padding: 0em;

    @media screen and (max-width: 768px){
        padding: 0;
        max-width: 100%;

    }
`

export const ContactsTextWrapper = styled.div`
margin-top: 100px;
    text-align: center;
`

export const ContactWrapper = styled.div`
    width: 100%;
`

export const ContactRow = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding: 50px 20px;
    @media screen and (max-width: 768px){
        flex-direction: column;
        justify-content: center;
        padding: 0;
        align-items: center;
    }
`

export const ContactInfoContainer = styled.div`
    margin-top: 100px;
    margin-bottom: 100px;
    position: relative;
    // background: gray;
    width: 650px;
    height: 350px;

    @media screen and (max-width: 1400px){
           margin-top: 30px;
           margin-bottom: 30px;

    }

    @media screen and (max-width: 768px){
        padding-left: 0;
        margin-top: 30px;
        margin-bottom: 30px;
         height: auto;
    }

     @media screen and (max-width: 480px){
        width: 100%;
        margin: 0;
         height: auto;
         padding: 25px;
    }

`

export const ContactElementText = styled.span`
    font-size: .8rem;
`

export const ContactCard = styled.div`
position: relative;
display: flex;
flex-direction: row;
    background: white;
    width: 100%;
    height: 100%;
    box-shadow:
     0 0em 3em rgb(0 0 0 / 30%),
    0 0 0 2px white,
    0.3em 0.3em 1em rgb(0 0 0 / 60%);
}

 @media screen and (max-width: 768px){
 flex-direction: column;

        padding-left: 0;
        margin: 0;
    }
`

export const ContactCardRight = styled.div`
padding: 10px;
    width: 32%;
    z-index: 2;


 @media screen and (max-width: 768px){
       
        width: 100%;
        margin: 0;
    }
`

export const ContactCardLeft = styled.div`
    margin: 50px;
    
    display: flex;
    flex-direction: column;
    padding: 0 20px 20px 20px;
    border-left: 2px solid black;
     @media screen and (max-width: 768px){
       
        width: 100%;
        margin:0;
         border-left: transparent;
    }
`

export const ContactsPortrait = styled.img`
    height: 100%;

    @media screen and (max-width: 768px){
        height: auto;
        width: 100%;
    }
`
    


export const ContactBottom = styled.div`
    background: rgba(134, 115, 46,.9);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 50px;
    // z-index: 2;

     @media screen and (max-width: 768px){
         background: transparent;
    }
`



export const ContactElement = styled.a`
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    margin: 10px 0;
    font-size: 1rem;

    .icon{
        color: ${theme.COLORS.PRIMARY};
    }
    .turn{
        transform: rotate(90deg);
    }

        &:hover .icon{
        color: ${theme.COLORS.DANGER};
        }
`

export const ContactText = styled.p`
    font-family: 'Roboto-regular', sans-serif;     
    font-weight: 600;
    color: #777;
    font-size: 17px;
    @media screen and (max-width: 768px){
        font-size: 15px;


    }
`

export const ContactsCard = styled.div`
    padding: 35px 50px;
    max-width: 49%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 0;
    margin: 0;
    height: 325px;
    border-radius: 50px;
    transition: all 0.2s ease-in-out;
    box-sizing: content-box;
    box-shadow: 0px 0px 20px 1px rgba(0,0,200,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    @media screen and (max-width: 768px){
        margin-top: 30px;
        max-width: 85%;
        padding: 10px;
        width: 100%;
    }
    
`


export const ContactsIconContainer = styled.div`
    justify-content: center;
    align-content: center;
    display: flex;
    width: 60px;
    margin-right: 15px;
`

export const ContactsIcon = styled.img`
    height: 65px;
    width: ${({width}) => (width ? width : '60px')};
    margin-bottom: 10px;
`

export const ContactsH1 = styled.h1`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    opacity: ${({transparent}) => (transparent ? .5 : 1)};
    margin-bottom: ${({transparent}) => (transparent ? '10px' : '0px')};
    @media screen and (max-width: 768px){
        font-size: 2rem;
        text-align: center;

    }
`

export const ContactInput = styled.textarea`
    outline: none;
    border: none;
    box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.1);
    width: 80%;
    height: 150px;
    margin-top: 35px;
    margin-bottom: 35px;
    resize: none;
    padding: 10px;
`

export const ContactsH2 = styled.h2`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: 1rem;
    font-weight:500;
    margin-bottom: 10px;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#000')};
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: .8rem;
        text-align: center;
    }
`
export const ContactsP = styled.p`
    font-family: 'Roboto-regular', sans-serif;     

    font-size: .8rem;
    text-align: center;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#777')};
`
export const ContactsMapContainer= styled.div`
    max-width: 60%;
    width: 100%;
    height: 350px;
`

